import { render } from "./Kibana.vue?vue&type=template&id=457952fe&ts=true"
import script from "./Kibana.vue?vue&type=script&lang=ts"
export * from "./Kibana.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__